import * as React from 'react';
import { useTheme, ThemeProvider, createTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';

import Button from '@mui/material/Button';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';

import Select from '@mui/material/Select';

import MenuItem from '@mui/material/MenuItem';

import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

import { v4 as uuidv4 } from 'uuid';

import {DndContext, useDroppable, useDraggable, DragOverlay} from '@dnd-kit/core';
import {PointerSensor, useSensor, useSensors} from '@dnd-kit/core';

import Bs4Tooltip, { Bs4HtmlTooltip, Bs4Tooltip01 } from '../Bs4Components/Bs4Tooltip';
import Bs4MainDispatch from '../Bs4MainDispatch';
import Bs4ReportGeneric from './Bs4ReportGeneric';
import Bs4I18N from '../Bs4I18N';
import { getFieldTheme } from '../Bs4Theme/Bs4Theme';
import { getBoxSx } from '../Bs4Theme/Bs4UxTemplates';
import Bs4Icon from '../Bs4Components/Bs4Icon'
import {isNullOrNaN} from '../Bs4Components/Bs4Utils';

const DRAG_DROP_MENU_ED = 'dragDropMenuEd';
const MENU_BUILDER = 'menuBuilder';
const DROPPABLE_START = 'DroppableStart';
const DROPPABLE_NEXT = 'DroppableNext';
const DRAGGABLE = 'Draggable';
const MENU_LOCATION = 'menuLocation';

//Edit menu
export default class Bs4ReportType55 extends Bs4ReportGeneric {

  createModel() {
    super.createModel();    
    this.dragDropMenuEd = JSON.parse(JSON.stringify(this.getPageParam(DRAG_DROP_MENU_ED)));
    this.menuBuilder = JSON.parse(JSON.stringify(this.getPageParam(MENU_BUILDER)));    
    this.menuLocation = this.getPageParam(MENU_LOCATION);
  }

  text_Delete = Bs4I18N.getTT("Delete", 'Usuń', 'Bs4ReportType55');
  text_folder = Bs4I18N.getTT("folder", 'folder', 'Bs4ReportType55');

  itemNextId = 1;
  getNextIdItem = () => String(this.itemNextId++);
  rootItem = null;

  updateItemAdd = (menuItems, key) => {
    for (let i = 0; i < menuItems.length; i++) {
      const item = menuItems[i];
      if (item.key === key) {
        const newItem = JSON.parse(JSON.stringify(item));
        item.key = uuidv4();
        delete newItem.add;
        return newItem;
      }
    }
  }

  removeItem = (menu, item) => {       
    if (!item) return null;
    if (!Array.isArray(menu.items)) return null;
    for (let i = 0; i < menu.items.length; i++) {
      const menuItem = menu.items[i];
      if (menuItem.key === item.key) {
        const item = menu.items.splice(i, 1)[0];
        menu.items = [...menu.items];
        return item;
      }
      const removed = this.removeItem(menuItem, item);
      if (removed) {
        menu.items = [...menu.items];
        return removed;
      }
    }
  }

  insertItem = (menu, sufix, key, item) => {
    if (!Array.isArray(menu.items)) return null;
    if (sufix === DROPPABLE_START && key === '') {
      menu.items.splice(0, 0, item);
      return menu;
    }
    for (let i = 0; i < menu.items.length; i++) {
      const menuItem = menu.items[i];
      if (menuItem.key === key) {
        if (sufix === DROPPABLE_START) {
          if (!Array.isArray(menuItem.items)) menuItem.items = [];
          menuItem.items.splice(0, 0, item);
        } else if (sufix === DROPPABLE_NEXT) {
          menu.items.splice(i+1, 0, item);
        } else {
          console.log('...insert item...Error...no sufix', sufix);
          return null
        }
        menu.items[i] = {...menuItem}
        return menuItem;
      } 

      const insertAt = this.insertItem(menuItem, sufix, key, item);
      if (insertAt) return insertAt;
    }
  }

  moveItem = (menuItems, menu, activeItem, id) => {
    let item = null;
    if (activeItem.add) {
      item = this.updateItemAdd(menuItems, activeItem.key);
    } else {
      item = this.removeItem(menu, activeItem);
    }
    if (!item) {
      console.log('...move item...Error...no item');  
      return;
    }
    const [sufix, key] = id.split('_');
    const insertAt = this.insertItem(menu, sufix, key, item)
    if (insertAt) {
      this.executeMove(activeItem, insertAt, sufix);
    } else {
      console.log('...move item...Error...no inserted', menu, sufix, key, item);
    }
  }  

  executeMove = (activeItem, insertAt, sufix) => { 
    console.log('...executeMove...', sufix, activeItem, insertAt);
    const details = {};
    if (activeItem.add) {
      details.operation = 'add';
      details.menuElementType = activeItem.bs4Id || activeItem.bs4FolderId;
    } else {
      details.operation = 'move';
      if (activeItem.bs4FolderId) {
        details.currentFolderId = activeItem.bs4FolderId;
      } else if (activeItem.bs4Id) {
        details.currentPageId = activeItem.bs4Id;
      } else {        
      }      
    }

    if (sufix === DROPPABLE_START) {
      if (insertAt.bs4FolderId) {
        // b- dodanie nowej opcji w istniejącym folderze na początku folderu  - dropInFolderId
        details.dropInFolderId = insertAt.bs4FolderId;
      } if (insertAt.bs4Id) {
        // Error. Nie możliwe. Nie zgoden ze specyfikacją.
      } else {
        // d- dodanie nowej opcji jako nowy folder+opcja jako pierwszy folder (jako jedyny lub przed wszystkimi istniejącymi) - bez parametru
      }  
    } else if (sufix === DROPPABLE_NEXT) {
      if (insertAt.bs4FolderId) {
        // c- dodanie nowej opcji jako nowy folder+opcja za innym folderem  - dropAfterFolderId
        details.dropAfterFolderId = insertAt.bs4FolderId;
      } else if (insertAt.bs4Id) {
        // a- dodanie nowej opcji w istniejącym folderze za jakimś elementem - dropAfterPageId
        details.dropAfterPageId = insertAt.bs4Id || insertAt.bs4FolderId;
      } else {
        // Error. Nie możliwe. Nie zgoden ze specyfikacją.
      }  
    } else {
      // Error. Nie możliwe. Nie zgoden ze specyfikacją.
    }

    console.log('...executeMove...', details)
    Bs4MainDispatch.commandParser('bs4SaveMenuEditor', details, this.bs4KartotekaId);
  }

  executeDelete = (activeItem) => {
    // operation: delete
    // currentPageId: id strony jeśli przeciągnięto stronę do usunięcia
    // currentFolderId: id folderu jeśli przeciągnięto folder do usunięcia
    if (activeItem.add) {
      console.log('...ERROR.delete.1.', activeItem);
      return;
    } 

    const details = {};
    details.operation = 'delete';
    if (activeItem.bs4FolderId) {
      details.currentFolderId = activeItem.bs4FolderId;
    } else if (activeItem.bs4Id) {
      details.currentPageId = activeItem.bs4Id;
    } else { 
      console.log('...ERROR.delete.2.', activeItem);
      return;  
    }

    console.log('...executeDelete...', details)
    Bs4MainDispatch.commandParser('bs4SaveMenuEditor', details, this.bs4KartotekaId);
  }

  sortCollisionsAsc = ({data: {value: a}}, {data: {value: b}}) => a - b;  

  customCollisionDetectionAlgorithm = (props) => {
    const {active, droppableContainers, droppableRects, ...args} = props;      
    const collisionDetectionArray = [];

    for (const droppableContainer of droppableContainers) { 
      // console.log('...CollisionDete...', droppableContainer.data.current?.item?.level, droppableContainer.data.current)
      if (active.data.current?.item?.bs4FolderId) {
        if (droppableContainer.id.startsWith(DROPPABLE_START) && droppableContainer.data.current?.item?.level > 0) continue;
        if (droppableContainer.id.startsWith(DROPPABLE_NEXT) && droppableContainer.data.current?.item?.level > 1) continue;
        if (active?.data?.current?.item?.bs4FolderId && false) continue;
      }
            
      const {id} = droppableContainer;
      // const rx = props.collisionRect.left || props.pointerCoordinates.x;
      // const ry = props.collisionRect.top || props.pointerCoordinates.y;
      const rx = props.pointerCoordinates.x;
      const ry = props.pointerCoordinates.y;
      const rect = droppableContainer?.node?.current?.getBoundingClientRect();
      if (rect) {
        let r = 0;
        if (rect.left <= rx && rect.right >= rx && 
            rect.top <= ry && rect.bottom >= ry) {
          r = 0;
        } else if (rect.left <= rx && rect.right >= rx) {
          r = Math.min(Math.abs(rect.top - ry), Math.abs(rect.bottom - ry))
        } else if (rect.top <= ry && rect.bottom >= ry) {
          r = Math.min(Math.abs(rect.left - rx), Math.abs(rect.right - rx))
        } else {
          const x = Math.min(Math.abs(rect.left - rx), Math.abs(rect.right - rx))
          const y = Math.min(Math.abs(rect.top - ry), Math.abs(rect.bottom - ry))
          r = Math.sqrt(x * x + y * y);
        }

        collisionDetectionArray.push({id, data: {droppableContainer, value: r}})
      }
    }
        
    const lastCollisionDetectionArray = collisionDetectionArray.sort(this.sortCollisionsAsc);
    // console.log('...sssssssssssss...', lastCollisionDetectionArray.length, lastCollisionDetectionArray)

    //this.scrollToVisable(props.pointerCoordinates);
    return lastCollisionDetectionArray;
  };
  
  /////////////////// form field /////////////////////////////
  getValue() {
    return null;
  }

  resetOriginalValue() {
  }  

  isDifferentValues (oldValue, newVaue) {
    return false;
  }

  clear() {
  }
  //////////////////////////////////////////////////////////
  
  static SORT_DIR_ASC = 'ASC';
  static SORT_DIR_DESC = 'DESC';

  defaultUxTemplate = {
    class: 189,
    name: 'Bs4ReportType53',
    body: {        
      Report55: {
        panel: {
          backgroundColor: "rgba(255, 255, 255, 1)",
        },         
      },        
    },
  };

  reload = () => {
    console.log('...Type55...reload...not.implemented...!!!')
  }
  
  activeItemOver = null;
  activeItemOverView = null;
  
  Droppable = (props) => {
    const report = this;    
    const {isOver, active, setNodeRef} = useDroppable({
      id: props.id,
      data: {item: props.item}
    });
    const dropable = React.useRef({});
    dropable.current.active = active;

    return <report.DroppableView {...props} isOver={isOver} setNodeRef={setNodeRef} dropable={dropable}/>;
  };

  DroppableView = React.memo((props) => {
    const report = this;
    const sx = React.useMemo(() => {
      const sx = props.sx || {};      
      if (props.direction === 'row') {
        sx.height = '100%'
      } else {
        sx.width = '100%'
      }

      // if (isOver && activeItem || true) {
      //   sx.backgroundColor = '#888888';
      //   sx.border = 'solid #aaaaaa';        
      // }      
      
      return sx;
    }, [props.isOver, props.sx, props.direction])
  
    return (
      <Box ref={props.setNodeRef} id={props.id} sx={sx}>
        <Collapse in={props.isOver} orientation={props.direction === 'row' ? 'horizontal' : 'vertical'}>
          <Box sx={{opacity: 0}}>
            <report.ViewMenuItem item={props.dropable?.current?.active?.data?.current?.item} passive/>
          </Box>
        </Collapse>
      </Box>
    );
  });

  DroppableDelete = (props) => {
    const report = this;
    const theme = useTheme();
    const {isOver, active, setNodeRef} = useDroppable({id: 'DroppableDelete'});    

    let variant = null;
    let color = theme.palette.action.disabled;
    let text = report.text_Delete;
    if ((isOver || props.deleting) && !props.activeItem?.add) {      
      if (props.activeItem?.bs4FolderId) {
        variant = 'h5';
        text = report.text_Delete+' '+report.text_folder;
        if (props.activeItem.items.length > 0) text += ' (+'+props.activeItem.items.length+')';
        color = theme.palette.warning.dark;
      } else if (props.activeItem?.bs4Id) {
        variant = 'h6';
        color = theme.palette.warning.main;
      }
    } else {
      if (props.activeItem && !props.activeItem.add) {
        if (props.activeItem?.bs4FolderId) {
          color = null;
        } else if (props.activeItem?.bs4Id) {
          color = null;
        }
      }
    }

    return (
      <Box 
        ref={setNodeRef} 
        //id={props.id} 
        //sx={props.sx} 
        sx={{p: 2, flex: 1}}
        display='flex' 
        flexDirection='column' 
        alignItems='flex-start'
        borderRadius={theme.shape.borderRadius+'px'}
      >
        <Typography variant={variant} color={color}>
          <i className="fa-solid fa-trash"/>
          &nbsp; &nbsp;
          {text}
        </Typography>
        <Collapse in={(isOver || props.deleting) && !props.activeItem?.add}>
          <Box sx={{maxHeight: '25vh', opacity: props.deleting ? 1 : 0}}>
            {props.deleting 
            ? <report.ViewMenuItemDraggable item={props.activeItem} passive/> 
            : <report.ViewMenuItem item={props.activeItem} passive/> 
            }            
          </Box>
        </Collapse>
      </Box>
    );
  }

  ViewMenuItems = (props) => {
    const report = this;
    const {setNodeRef} = useDroppable({id: 'ViewMenuItems'}); 
    
    return (      
      <Box ref={setNodeRef} overflow='auto' sx={props.sx} padding={1}>
        {(props.menuItems || []).map(item =>          
          <report.ViewMenuItemDraggable
            key={item.key} 
            item={item}
            passive
            add
          />
        )}
      </Box>            
    )
  }

  getItemTitle = (item) => {
    return (item?.text);
    // return (item?.text || '?');
    // return (item?.text || '?') + ':' + item.key;
    // return (item?.text || '?') + ':' + (item.bs4FolderId || '') + ' ' + (item.bs4Id || '');
  }

  ViewMenuItemDraggable = (props) => {
    const report = this;
    const {setNodeRef, setActivatorNodeRef, listeners, isDragging} = useDraggable({
      id: DRAGGABLE+'_'+props.item?.key, 
      data: {
        item: props.item,
      }
    });

    if (!props.item) return null;
    if (isDragging) return null;

    return (
      <report.ViewMenuItem {...props} setNodeRef={setNodeRef} setActivatorNodeRef={setActivatorNodeRef} listeners={listeners}/>
    )
  }

  ViewMenuItem = React.memo((props) => {
    const report = this;
    const mainTheme = useTheme();  
    const theme = React.useMemo(() => createTheme(getFieldTheme(mainTheme, props.item?.bs4CustomCss)), [mainTheme])
    // if (!props.item?.iconCls) props.item.iconCls = 'fa-regular fa-period';
    const draggableProps = React.useMemo(() => {
      if (props.setNodeRef && props.listeners) return {
        ref: props.setNodeRef, 
        ...props.listeners,
      };
      return {};
    }, [props.setNodeRef, props.listeners])

    // console.log('...ViewMenuItem...', report.getItemTitle(props.item), props.item?.bs4CustomCss, theme);
    
    // 3. Uwagi prośby:
    // a)
    // - na każdej opcji i folderze w edytowanym menu prośba aby dodać ikonę trybika za nazwą, która wywołuje edytor strony lub folderu. 
    // com:Bs4OpenCard
    // targetObject: id opcji lub folderu
    // targetOption:300 jeśli kliknięto opcję, 299 jeśli kliknięto folder

    const handleGear = () => {
      const details = {
        targetObject: props.item.bs4Id || props.item.bs4FolderId,
        targetOption: Boolean(props.item.bs4FolderId) ? 299 : 300,
      }
      Bs4MainDispatch.commandParser('Bs4OpenCard', details, this.bs4KartotekaId);
    }

    if (!props.item) return null;

    const divider = props.item?.text?.startsWith('------');

    
    return (
      <ThemeProvider theme={theme}>
        <Box p={0.5}>
          <Stack 
            ref={props.setNodeRef} 
            // {...draggableProps}
            direction="column" 
            justifyContent="flex-start"
            alignItems="flex-start" 
            sx={{            
              backgroundColor: theme.palette.background.default,
              color: theme.palette.primary.main,
              boxShadow: theme.shadows[1],
              borderRadius: theme.shape.borderRadius+'px',
            }}
          >
            <Bs4Tooltip01
              // title={Boolean(props.item?.tooltip) ? <div dangerouslySetInnerHTML={{__html: props.item?.tooltip}}/> : ''}
              title={props.item?.tooltip}
              arrow 
              placement="top"
              //placement="bottom-start"
              describeChild
            >
              <ListItem id={props.item?.key} dense>            
                <ListItemButton
                  ref={props.setActivatorNodeRef} 
                  {...props.listeners}
                  disableGutters
                >              
                  {divider 
                  ? 
                  <Divider sx={{width: '100%'}}>Divider</Divider>
                  :
                  <React.Fragment>
                    <ListItemIcon sx={{justifyContent:'center'}}>
                      <Bs4Icon iconCls={props.item?.iconCls} iconStyle={props.item?.iconStyle}/>
                    </ListItemIcon>
                    <ListItemText primary={report.getItemTitle(props.item)} primaryTypographyProps={{noWrap: true}}/>                  
                  </React.Fragment>
                  }
                </ListItemButton>
                {props.add ? null :
                <IconButton edge='end' onClick={handleGear}>
                  <i className="fa-solid fa-gear"/>
                </IconButton>}
              </ListItem>
            </Bs4Tooltip01>
            {props.add || props.level > 0 ? null :
              <List disablePadding sx={{pl: 3, m: 0, width: '100%'}}>
                {!props.passive && !divider ? <report.Droppable id={DROPPABLE_START+'_'+props.item?.key} item={props.item}/> : null}        
                {(props.item?.items || []).map(itemChild => {
                  return (
                    <React.Fragment key={itemChild.key}>           
                      {props.passive
                        ? <report.ViewMenuItem item={itemChild} level={props.level + 1} passive/>  
                        : <report.ViewMenuItemDraggable item={itemChild} level={props.level + 1}/>
                      }
                      {!props.passive && !divider ? <report.Droppable id={DROPPABLE_NEXT+'_'+itemChild.key} item={itemChild}/> : null}
                    </React.Fragment>
                  )
                })}
              </List>
            }
          </Stack>
        </Box>
      </ThemeProvider>
    )
  });

  scrollToVisable = (pointer) => {    
    if (!this.ruilderRef.current) return;
    const rect = this.ruilderRef.current.getBoundingClientRect();
    if (pointer.x < rect.left)    this.ruilderRef.current.scroll({left: 0, behavior: 'smooth'});
    if (pointer.x > rect.right)   this.ruilderRef.current.scroll({left: 99999999, behavior: 'smooth'});
    if (pointer.y < rect.top)     this.ruilderRef.current.scroll({top: 0, behavior: 'smooth'});
    // if (pointer.y > rect.bottom)  this.ruilderRef.current.scroll({top: 99999999, behavior: 'smooth'});
  } 

  ViewMenuBuilder = (props) => {
    const report = this;
    this.ruilderRef = React.useRef(null);
    console.log('...Builder...', props);
    
    return (
      <Stack
        ref={report.ruilderRef}
        direction={props.menuLayout}
        justifyContent="flex-start" 
        alignItems="flex-start" 
        height='100%' 
        width='100%'
        overflow='auto' 
        sx={props.sx}
        useFlexGap
      >
        <report.Droppable id={DROPPABLE_START+'_'} direction={props.menuLayout} item={props.menu}/>
        {(props.menu.items || []).map(item => 
          <React.Fragment key={item.key}>           
            <report.ViewMenuItemDraggable item={item} level={0}/>
            <report.Droppable id={DROPPABLE_NEXT+'_'+item.key} direction={props.menuLayout} item={item}/>
          </React.Fragment>
        )}
      </Stack>
    )
  }

  getMenuItemFromVariant = (variant) => {
    const [bs4Id, text, tooltip, iconCls, bs4CustomCss, iconStyle] =  variant;
    return {
      key: uuidv4(),
      bs4Id: String(bs4Id).trim(), 
      text: String(text || ''), 
      tooltip: String(tooltip || ''), 
      iconCls: iconCls || null, 
      bs4CustomCss, 
      iconStyle,
      add: true,
    };
  }  

  getMenuItems = (menu) => {
    menu.key = menu.key || uuidv4();
    if (isNullOrNaN(parseInt(menu.level))) menu.level = 0;
    if (Array.isArray(menu.items)) menu.items = menu.items.map(item => {
      item.level = menu.level + 1;
      this.getMenuItems(item);      
      return {...item};
    })
    return menu;
  }

  ViewAskToConfirmDelete = (props) => {
    const theme = useTheme();    

    const handleOk = () => {      
      if (props.ask?.ok) props.ask.ok();
    };

    const handleCancel = () => {      
      if (props.ask?.cancel) props.ask.cancel();     
    };

    if (!props.activeItem) return null;
  
    return (
      <Dialog open={Boolean(props.ask?.open)}>
        <DialogTitle>{props.activeItem.text}</DialogTitle>
        <DialogContent>                    
          <Stack direction="row" justifyContent='flex-start' alignItems="center" spacing={2}>
            <Typography variant='h4' color={theme.palette.warning.main}>
              <i className="fa-solid fa-triangle-exclamation"/>
            </Typography>  
            <DialogContentText>{'Usunąć ?'}</DialogContentText>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleOk}>Tak</Button>
          <Button onClick={handleCancel} autoFocus>Nie</Button>
        </DialogActions>
      </Dialog>
    )
  }

  menuLayouts = ['row', 'column']

  ViewComponent = React.forwardRef((props, ref) => {
    const report = this;
    const theme = useTheme();
    this.borderRadius = theme.shape.borderRadius;
    const [activeItem, setActiveItem] = React.useState(null)
    const [menuLayout, setMenuType] = React.useState(() => {
      console.log('...Bs4ReportType55...menuLocation', this.menuLocation)
      if ('left' === this.menuLocation) return this.menuLayouts[1];
      return this.menuLayouts[0];
    }, []);
    const [menuItems, setMenuItems] = React.useState(() => {
      return (this.dragDropMenuEd || []).map(variant => {
        const menuItem = this.getMenuItemFromVariant(variant);
        menuItem.boxSx = getBoxSx(menuItem.bs4CustomCss, theme);
        return menuItem;
      });      
    });
    const [menu, setMenu] = React.useState(() => {
      return this.getMenuItems({items: this.menuBuilder});
    });

    const [deleting, setDeleting] = React.useState(false);
    const [moving, setMoving] = React.useState(false);
    const [askDelete, setAskDelete] = React.useState(null);

    const sensors = useSensors(
      useSensor(PointerSensor, {
        activationConstraint: {
          //distance: 10,
          //delay: 100,
          //tolerance: 15,
        },
      })
    );

    React.useEffect(() => {
      this.menuStructureRefresh = (message) => {        
        console.log('...menuStructureRefresh...', message);
        this.menuBuilder = message?._Komunikat?.menuBuilder || [];
        setActiveItem(null);
        setDeleting(false);
        setMenu(this.getMenuItems({items: this.menuBuilder}));        
      }
    }, [setActiveItem, setMenu, setDeleting]);

    const handleDragStart = (event) => {            
      const item = event.active.data.current.item;
      console.log('...DragStart..', item, event)       
      setActiveItem(item);      
    }

    const handleDragEnd = (event) => {      
      const menuPrev = JSON.parse(JSON.stringify(menu));
      console.log('...DragEnd...', event, activeItem);
      if (event.over?.id && event.over?.id !== 'ViewMenuItems' && event.over?.id !== 'DroppableDelete') {
        this.moveItem(menuItems, menu, activeItem, event.over.id);      
        setMenu({...menu});
        // setActiveItem(null);
      }

      if (activeItem && !activeItem?.add && event.over?.id && event.over?.id === 'DroppableDelete') {                  
        if (activeItem === this.removeItem(menu, activeItem)) {     
          setDeleting(true);          
          setMenu({...menu});
          setAskDelete({
            open: true,
            ok: () => {
              this.executeDelete(activeItem);
              setAskDelete(null);
              setDeleting(false);
            },
            cancel: () => {      
              setAskDelete(null);
              setMenu(menuPrev);        
              setActiveItem(null);
              setDeleting(false);              
            },
          })
        } else {
          console.log('...delete item...Error...no item', activeItem, activeItem);  
        }        
      }
    }

    const handleDragCancel = (event) => {
      console.log('...DragCancel...', event.active?.id, event)    
      setActiveItem(null);
    }

    // console.log('...ViewComponent.55...', menuItems, menu)

    return (
      <Box ref={ref} height='100%' width='100%' display='flex' flexDirection="column" overflow='hidden' px={props.uxKartoteka?.spacing}>        
        <Box pt={props.uxKartoteka?.spacing / 3}/>
        <DndContext 
          // autoScroll={false}
          onDragStart={handleDragStart}
          onDragEnd={handleDragEnd} 
          onDragCancel={handleDragCancel}
          // collisionDetection={closestCenter}
          collisionDetection={report.customCollisionDetectionAlgorithm}
          // sensors={sensors}
        >
          <Box flex={1} display='flex' flexDirection='row' overflow='hidden'>
            <report.ViewMenuItems menuItems={menuItems} sx={{}}/>
            <report.ViewMenuBuilder menu={menu} menuLayout={menuLayout} sx={{flex: 1, overflow:'auto', p: 1}}/>
          </Box>
          <DragOverlay style={{width: 'auto'}}><report.ViewMenuItem item={activeItem} passive/></DragOverlay>
          <Stack direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={1}>
            <report.DroppableDelete activeItem={activeItem} deleting={deleting}/>
            <Select
              sx={{p: 1}}
              value={menuLayout}
              autoWidth
              onChange={(event) => setMenuType(event.target.value)}
            >
              <MenuItem value={report.menuLayouts[0]}>Horizontal</MenuItem>
              <MenuItem value={report.menuLayouts[1]}>Vertical</MenuItem>
            </Select>
          </Stack>
        </DndContext>
        <report.ViewAskToConfirmDelete activeItem={activeItem} ask={askDelete}/>  
      </Box>
    )
  });
}